import { useDataChange, useDataValue } from 'Simple/Data.js'

export function useOnSave(props) {
  let change = useDataChange({
    context: 'letter',
    viewPath: props.viewPath,
  })

  return function save(recipient_id, postal_address_id) {
    change(next => {
      next.recipient_id = recipient_id
      next.postal_address_id = postal_address_id
    })
  }
}

export function useIsTemplateEligibleForExternalProfessional(props) {
  let letter = useDataValue({
    context: 'letter',
    viewPath: props.viewPath,
  })

  let external_professional_templates = useDataValue({
    context: 'external_professional_templates',
    viewPath: props.viewPath,
  })

  return (
    letter.template_id &&
    external_professional_templates?.some(
      template => template._id === letter.template_id
    )
  )
}

export function isTemplateEligibleForExternalProfessional(
  letter,
  external_professional_templates
) {
  return (
    letter.document_template_id &&
    external_professional_templates?.some(
      template => template._id === letter.document_template_id
    )
  )
}
